/**
 * Formata um número para moeda (EUR)
 */
export function formatCurrency(value: number): string {
  return new Intl.NumberFormat('pt-PT', {
    style: 'currency',
    currency: 'EUR'
  }).format(value);
}

/**
 * Formata uma data para o formato local (pt-PT)
 */
export function formatDate(date: Date | string): string {
  if (typeof date === 'string') {
    date = new Date(date);
  }
  return new Intl.DateTimeFormat('pt-PT', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  }).format(date);
}

/**
 * Formata uma data e hora para o formato local (pt-PT)
 */
export function formatDateTime(date: Date | string): string {
  if (typeof date === 'string') {
    date = new Date(date);
  }
  return new Intl.DateTimeFormat('pt-PT', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  }).format(date);
}

/**
 * Formata um número de telefone português
 */
export function formatPhoneNumber(phone: string): string {
  // Remove todos os caracteres não numéricos
  const cleaned = phone.replace(/\D/g, '');
  
  // Verifica se é um número português (9 dígitos)
  if (cleaned.length === 9) {
    return cleaned.replace(/(\d{3})(\d{3})(\d{3})/, '$1 $2 $3');
  }
  
  // Se não for um número português, retorna como está
  return phone;
}

/**
 * Formata um NIF português
 */
export function formatVAT(vat: string): string {
  // Remove todos os caracteres não numéricos
  const cleaned = vat.replace(/\D/g, '');
  
  // Verifica se é um NIF português (9 dígitos)
  if (cleaned.length === 9) {
    return cleaned.replace(/(\d{3})(\d{3})(\d{3})/, '$1 $2 $3');
  }
  
  // Se não for um NIF português, retorna como está
  return vat;
}

/**
 * Formata um código postal português
 */
export function formatPostalCode(postalCode: string): string {
  // Remove todos os caracteres não numéricos
  const cleaned = postalCode.replace(/\D/g, '');
  
  // Verifica se é um código postal português (7 dígitos)
  if (cleaned.length === 7) {
    return cleaned.replace(/(\d{4})(\d{3})/, '$1-$2');
  }
  
  // Se não for um código postal português, retorna como está
  return postalCode;
}

/**
 * Formata um número com separador de milhares
 */
export function formatNumber(value: number): string {
  return new Intl.NumberFormat('pt-PT').format(value);
}

/**
 * Formata um valor em percentagem
 */
export function formatPercentage(value: number): string {
  return new Intl.NumberFormat('pt-PT', {
    style: 'percent',
    minimumFractionDigits: 1,
    maximumFractionDigits: 1
  }).format(value / 100);
}

/**
 * Formata um valor em quilogramas
 */
export function formatWeight(value: number): string {
  return new Intl.NumberFormat('pt-PT', {
    style: 'unit',
    unit: 'kilogram',
    minimumFractionDigits: 1,
    maximumFractionDigits: 1
  }).format(value);
}

/**
 * Formata bytes em uma unidade legível (KB, MB, GB)
 */
export function formatBytes(bytes: number): string {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
}
